import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { Icon } from "../AgentAnalytics/ds";
import tokens from "../AgentAnalytics/designTokens";

const useStyles = makeStyles({
  wrap: { position: "relative", flexShrink: 0, display: "inline-flex" },
  mark: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: tokens.textOnDark,
    pointerEvents: "none",
  },
});

// Wraps a thumbnail and marks it as a video when `show` is true.
export default function PlayOverlay({ show, size = 18, children }) {
  const classes = useStyles();
  if (!show) return children;
  return (
    <Box className={classes.wrap} data-testid="play-overlay">
      {children}
      <span className={classes.mark}>
        <Icon name="video" size={size} />
      </span>
    </Box>
  );
}
